import React, { useEffect, useState } from 'react';
import * as helpers from "../../Helper/utils"
import "./ReviewBlocks.css"
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import PeopleIcon from '@mui/icons-material/People';
import { FactCheck } from '@mui/icons-material';
import { FactChecking } from '../Home/factChecking';
import { isAiActivated } from '../../HTTP/articles';
import { sendReviewReadNotification } from '../../HTTP/user';
import globe from '../../media/globe.png';
import zemusLogo from '../../media/z.png';
import RecommendToFriendPopup from '../Common/RecommendToFriendPopup';
import useCurrentLanguage from '../../Helper/useCurrentLanguage';
const ReviewBlocks = ({ reviews, onDeleteReview, edition, displayAuthor, favorites, handleAddFav, handleRemFav }) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const currentLanguage = useCurrentLanguage();
  const isFrenchLanguage = currentLanguage.startsWith("fr");
  console.log(reviews)

  const CountBadge = ({ backgroundColor, count, label, textColor = "#FFFFFF" }) => (
    <span
      className="min-w-[28px] h-7 px-2 rounded-full text-white text-sm font-bold inline-flex items-center justify-center shadow-md whitespace-nowrap"
      style={{ backgroundColor, color: textColor }}
    >
      {label} : {count || 0}
    </span>
  );

  const [showPopUpFactChecking, setShowPopUpFactChecking] = useState(false);
  const [choosenReviewArticleId, setChoosenReviewArticleId] = useState(null);
  const [aiActivated, setAiActivated] = useState(false);
  const [selectedReviewIdForRecommendation, setSelectedReviewIdForRecommendation] = useState(null);

  useEffect(() => {
    const fetchAiActivated = async () => {
      try {
        const res = await isAiActivated();
        console.log("isAiActivated", res)
        if (res !== undefined) {
          setAiActivated(res.value === '1');
        }
      } catch (error) {
        console.error("Error fetching AI activation status:", error);
      }
    }
    fetchAiActivated();
  }, [])

  console.log(handleRemFav)
  console.log(handleAddFav)
  console.log(favorites)

  const handleViewArticle = (link) => {
    const decodedLink = helpers.htmlDecode(link);

    // Vérifier si le lien commence par https://static.zemus.info
    if (decodedLink.startsWith('https://static.zemus.info')) {
      helpers.goToStaticPage(true, link.split('id=')[1].split('&')[0]);
    } else {
      window.open(decodedLink, '_blank');
    }
  }

  const handleSendReviewNotification = async (friendId) => {
    if (!selectedReviewIdForRecommendation || !friendId) return false;
    const res = await sendReviewReadNotification(selectedReviewIdForRecommendation, friendId);
    if (res) {
      alert("Notification envoyee");
      return true;
    }
    alert("Erreur lors de l'envoi de la notification");
    return false;
  };

  return (
    <div className={`reviews-container flex flex-wrap mr-2 ml-2 ${isFrenchLanguage ? "notranslate" : ""}`} translate={isFrenchLanguage ? "no" : undefined}>
      {reviews.map((review, reviewIndex) => (
        <div key={reviewIndex} className="review w-full lg:w-1/2 xl:w-1/3 mb-6">
          <div className="review-block bg-white rounded-lg shadow mr-2 ml-2 h-full">
            <div className="review-header p-4 block rounded-t-lg relative">
              <button onClick={() => helpers.goToStaticPage(false, review.id)}>
                <strong className="block text-uppercase pr-8">{review.theme}</strong>
                {review.sharefriends ? (
                  <img className="w-6 absolute top-1 right-1" src={process.env.PUBLIC_URL + "/unlock.svg"} alt={"Revue non-bloquée"}></img>
                ) : (
                  <img className="flex absolute top-1 right-1 w-6" src={process.env.PUBLIC_URL + "/lock.svg"} alt={"Revue bloquée"}></img>
                )}
                <p className="block pt-2">{review.presentation.length > 150 ? review.presentation.slice(0, 149) + '...' : review.presentation}</p>
              </button>
              <div className="flex justify-between items-center mt-3">
                <CountBadge backgroundColor="#9cfdff" textColor="#000000" count={review.comments_count ?? review.commentsCount} label="Commentaires" />
                <CountBadge backgroundColor="#9cfdff" textColor="#000000" count={review.likes_count ?? review.likesCount} label="J'aime" />
              </div>
              {
                displayAuthor && (
                  <a href={`/friends/${review.user.id}`} className="flex items-center mt-2">
                    <div className="flex items-center mt-2">
                      <PeopleIcon />
                      <span className="ml-2">{review.user.firstname + " " + review.user.lastname}</span>
                    </div>
                  </a>
                )
              }
              <div className="review-date text-sm text-white flex justify-end mt-2">
                {helpers.formatDateExtended(review.creation_date)}
              </div>
            </div>
            <div className="review-inner pl-4 pr-4 pt-4 pb-1">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4" style={{ maxHeight: '300px', overflowY: 'scroll' }}>
                {review.articles &&
                  review.articles.map((article, articleIndex, { length }) => {
                    let colSpan = "col-span-1";
                    let heightSpan = "w-full h-24 object-cover rounded";
                    if (length === 3 && articleIndex === 0) {
                      colSpan = "md:col-span-2";
                      heightSpan = "w-full h-24 object-cover rounded";
                    } else if (length === 4) {
                      colSpan = "md:col-span-1";
                      heightSpan = "w-full h-24 object-cover rounded";
                    }

                    return (
                      <div key={articleIndex} className={`${colSpan}`}>
                        <div className="article-content bg-white rounded-lg shadow relative">
                          {
                            favorites !== undefined &&
                            (
                              favorites.some(fav => fav.link === helpers.htmlDecode(article.link)) ? (
                                <img
                                  className="absolute w-6 h-8 top-2 right-2"
                                  src={process.env.PUBLIC_URL + ("/bookmark.svg")}
                                  alt="favoris"
                                  onClick={() => handleRemFav(helpers.htmlDecode(article.link))}
                                />
                              ) : (
                                <img
                                  className="absolute w-6 h-8 top-2 right-2"
                                  src={process.env.PUBLIC_URL + ("/bookmarklight.svg")}
                                  alt="favoris"
                                  onClick={() => handleAddFav(article.title,
                                    helpers.htmlDecode(article.link),
                                    helpers.htmlDecode(article.image),
                                    user.country,
                                    new Date().toISOString().replace("T", " ").slice(0, 19),
                                    article.description.length > 150 ? article.description.slice(0, 50) + "..." : article.description)}
                                />
                              )
                            )
                          }
                          {
                            aiActivated && (
                              <>
                                <button
                                  onClick={() => {
                                    setChoosenReviewArticleId(article.id);
                                    setShowPopUpFactChecking(true);
                                  }}
                                  className="absolute w-8 h-8 top-2 left-2 bg-white rounded"
                                  style={{ backgroundColor: "#CBE1E1" }}
                                >
                                  <FactCheck />
                                </button>
                                {showPopUpFactChecking && choosenReviewArticleId === article.id && (
                                  <FactChecking articleLink={article.link} setShowPopUpFactChecking={setShowPopUpFactChecking} />
                                )}</>
                            )
                          }
                          {/* <img 
                          className="absolute w-6 h-8 top-2 left-2" 
                          src={process.env.PUBLIC_URL + ("/bookmarklight.svg")} 
                          alt="favoris"
                        /> */}
                          <button onClick={() => handleViewArticle(article.link)} className="flex flex-col w-full">
                            <img
                              src={helpers.htmlDecode(article.image || process.env.PUBLIC_URL + "/news_icon2.jpg")}
                              alt={article.title}
                              className={`${heightSpan}`}
                            />
                            <div className="article-title p-2">
                              <h3 className="py-1">{article.title}</h3>
                              <span className="article-origin block">
                                <strong>{article.country}</strong> | {helpers.getDomainName(article.link)}
                              </span>
                            </div>
                            {
                              article.link.startsWith("https://static.zemus.info") &&
                              <div className="static-article-indicator flex items-center justify-end p-2">
                                <img src={zemusLogo} alt="Zemus Logo" className=" h-6 mr-1" />
                              </div>
                            }
                            {
                              article.link.startsWith("https://static.zemus.info") === false &&
                              <div className="external-article-indicator flex items-center justify-end p-2">
                                <img src={globe} alt="Globe Icon" className="w-6 h-6 mr-1" />
                              </div>
                            }
                          </button>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className="review-footer mt-4 flex">
                <a
                  href={`https://static.zemus.info/?id=${review.id}&readerid=${user.id}`}
                  className="mr-2 mb-2 bg-validbutton hover:bg-validbuttonhover text-black font-bold py-2 px-4 rounded-full inline-flex items-center space-x-2"
                >
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    ></path>
                  </svg>
                </a>
                <button
                  type="button"
                  onClick={() => setSelectedReviewIdForRecommendation(review.id)}
                  title="Conseiller la lecture a un ami"
                  className="mr-2 mb-2 bg-validbutton hover:bg-validbuttonhover text-black font-bold py-2 px-4 rounded-full inline-flex items-center space-x-2"
                >
                  <ArrowOutwardIcon />
                </button>


                {edition && edition === "true" && (
                  <>
                    <a
                      href={`/editreviews/${review.id}`}
                      className="bg-gray-500 hover:bg-gray-700 text-white py-2 px-4 rounded-full flex items-center space-x-2 inline-block mr-2 mb-2"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                        <path
                          fillRule="evenodd"
                          d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10a2 2 0 002 2h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </a>

                    <button
                      onClick={() => onDeleteReview(review.id)}
                      className="bg-red-500 hover:bg-red-700 text-white py-2 px-4 rounded-full inline-flex items-center inline-block mb-2"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                      </svg>
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
      <RecommendToFriendPopup
        isOpen={selectedReviewIdForRecommendation !== null}
        onClose={() => setSelectedReviewIdForRecommendation(null)}
        onConfirm={handleSendReviewNotification}
        title="Recommander à un ami"
      />
    </div>
  );
};

export default ReviewBlocks;
